import { useEffect } from 'react';
import { useNavigate } from 'react-router';

import { readPendingJoinToken } from '@/entities/collab';

import { HomeDashboard } from './HomeDashboard';

/** `/app`: the dashboard. A join link opened while signed out is continued here after sign-in. */
export function AppHomePage() {
  const navigate = useNavigate();
  useEffect(() => {
    if (readPendingJoinToken() !== null) void navigate('/join', { replace: true });
  }, [navigate]);
  return <HomeDashboard />;
}
